import { signal } from '@angular/core';

export interface ApiState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

export function createApiState<T>(initial: T | null = null) {
  const state = signal<ApiState<any>>({
    data: initial,
    loading: false,
    error: null,
  });

  const start = () => state.update(s => ({ ...s, loading: true, error: null }));
  const success = (data: T) => state.update(s => ({ ...s, data, loading: false }));
  const fail = (error: string) => state.update(s => ({ ...s, loading: false, error }));

  return { state, start, success, fail };
}
